var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("nav", { staticClass: "tabnav" }, [
    _c(
      "ul",
      _vm._l(_vm.items, function(item) {
        return _c(
          "router-link",
          {
            key: item.name,
            staticClass: "bg-white",
            style: { transition: "all 1s", display: "inline-block" },
            attrs: { to: { name: item.name }, tag: "li" }
          },
          [
            _c("p", { staticClass: "text-small blueDark" }, [
              _vm._v(_vm._s(item.meta.literal))
            ])
          ]
        )
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }